<template>
  <div v-if="reviews.length">
    <ul class="timeline timeline-reversed">
      <li v-for="review in reviewsList" class="timeline-item">
        <reviewItem :review="review" tag="li" />
      </li>
    </ul>
    <div class="text-center">
      <button v-show="showMore" class="btn btn-primary" @click="fetchReviews">Show more</button>
      <h3 v-show="reviews.length && !showMore" class="text-center text-muted mt-3">No more reviews</h3>
    </div>
  </div>
  <div v-else class='empty-state text-center text-muted mt-6 mb-6'>
    <img :src="noReviews" alt="No Reviews Img" height=100>
    <h3 class='mt-4 mb-4'>This location doesn't have any reviews yet.</h3>
  </div>
</template>

<script>
import noReviews from 'no_data/reviews.svg'
import axios from 'axios'
import reviewItem from './item'

export default {
  components: { reviewItem },
  props: {
    reviews: Array
  },
  data() {
    return {
      noReviews: noReviews,
      page: 2,
      reviewsList: this.reviews,
      showMore: this.reviews.length === 10
    }
  },
  methods: {
    fetchReviews() {
      axios.get(`/api${window.location.pathname}`, { params: { page: this.page } })
        .then((res) => {
          this.page += 1
          if (res.data.length < 10) {
            this.showMore = false
          }
          this.reviewsList = this.reviewsList.concat(res.data)
        })
    }
  }
}
</script>

<style scoped>
</style>
